import api from 'api/index';
import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { fetchAllPages } from '../../../hooks/utils';
import {
  BONUS_COMPONENTS_PAGE_LIMIT,
  REARCH_BONUS_TYPES_QUERY_KEY,
  REARCH_BONUS_TYPES_QUERY_VARIABLES,
} from '../constants';
import { BonusLibraryItem } from '../types';
import { useReArchBonusEnabled } from './useReArchBonusEnabled';

export const useBonusTypes = () => {
  const isReArchEnabled = useReArchBonusEnabled();

  const query = useQuery(
    REARCH_BONUS_TYPES_QUERY_KEY,
    () =>
      fetchAllPages(async (offset, limit) => {
        const response = await api.bonusAssignment.queries.listBonusComponents({
          input: { ...REARCH_BONUS_TYPES_QUERY_VARIABLES, limit, offset },
        });
        return {
          items: response?.payrollListFlexibleBenefitsComponents?.data ?? [],
          totalCount: response?.payrollListFlexibleBenefitsComponents?.total_count ?? 0,
        };
      }, BONUS_COMPONENTS_PAGE_LIMIT),
    { enabled: isReArchEnabled },
  );

  const bonusTypes: BonusLibraryItem[] = useMemo(
    () =>
      (query.data ?? []).map((component) => ({
        value: component.id,
        title: component.name,
        taxDeductionBehaviour:
          component.settings?.flexible_settings?.tax_behaviour?.tax_deduction_behaviour ?? null,
      })),
    [query.data],
  );

  return { ...query, bonusTypes };
};
